import React from 'react';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-secondary text-white">
      {/* Main footer */}
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="font-display text-2xl font-bold">
                <span className="text-white">Pet</span>
                <span className="text-primary-light">Mas</span>
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-white/70">
              Tu tienda de mascotas de confianza en Peru. Ofrecemos los mejores
              productos para el cuidado y bienestar de tus mascotas con envio
              a todo el pais.
            </p>
            <div className="flex gap-3 mt-6">
              <SocialLink href="https://facebook.com/petmaspe" label="Facebook">
                <FacebookIcon className="w-5 h-5" />
              </SocialLink>
              <SocialLink href="https://instagram.com/petmaspe" label="Instagram">
                <InstagramIcon className="w-5 h-5" />
              </SocialLink>
              <SocialLink href="https://tiktok.com/@petmaspe" label="TikTok">
                <TikTokIcon className="w-5 h-5" />
              </SocialLink>
              <SocialLink href="https://wa.me/51980999990" label="WhatsApp">
                <WhatsAppIcon className="w-5 h-5" />
              </SocialLink>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-primary-light text-lg font-semibold mb-4 border-b border-primary-light pb-2">
              Categorias
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <FooterLink to="/perros">Perros</FooterLink>
              </li>
              <li>
                <FooterLink to="/gatos">Gatos</FooterLink>
              </li>
              <li>
                <FooterLink to="/prendas">Prendas</FooterLink>
              </li>
              <li>
                <FooterLink to="/placas">Placas</FooterLink>
              </li>
              <li>
                <FooterLink to="/farmacia">Farmacia</FooterLink>
              </li>
              <li>
                <FooterLink to="/outlet">Outlet</FooterLink>
              </li>
              <li>
                <FooterLink to="/blog">Blog</FooterLink>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="text-primary-light text-lg font-semibold mb-4 border-b border-primary-light pb-2">
              Atencion al Cliente
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <FooterLink to="/quienes-somos">Quienes Somos</FooterLink>
              </li>
              <li>
                <FooterLink to="/contacto">Contacto</FooterLink>
              </li>
              <li>
                <FooterLink to="/privacidad">Politica de Privacidad</FooterLink>
              </li>
              <li>
                <FooterLink to="/terminos">Terminos y Condiciones</FooterLink>
              </li>
              <li>
                <FooterLink to="/reclamos">Libro de Reclamaciones</FooterLink>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-primary-light text-lg font-semibold mb-4 border-b border-primary-light pb-2">
              Contacto
            </h3>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-3">
                <LocationIcon className="w-5 h-5 flex-shrink-0 mt-0.5 text-primary-light" />
                <span>Pasaje Sucre 135, Miraflores, Lima, Peru</span>
              </li>
              <li className="flex items-center gap-3">
                <PhoneIcon className="w-5 h-5 flex-shrink-0 text-primary-light" />
                <div className="flex flex-col">
                  <a href="tel:+51980999990" className="hover:text-primary-light transition-colors">
                    +51 980 999 990
                  </a>
                  <a href="tel:+51922494441" className="hover:text-primary-light transition-colors">
                    +51 922 494 441
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <EmailIcon className="w-5 h-5 flex-shrink-0 text-primary-light" />
                <a href="mailto:compras@petmas.pe" className="hover:text-primary-light transition-colors">
                  compras@petmas.pe
                </a>
              </li>
            </ul>

            {/* Newsletter */}
            <div className="mt-6">
              <p className="text-sm text-white/70 mb-2">Suscribete al boletin</p>
              <form className="flex">
                <input
                  type="email"
                  placeholder="Tu email"
                  className="flex-1 px-3 py-2 text-sm rounded-l bg-white text-gray-800 focus:outline-none"
                />
                <button
                  type="submit"
                  className="px-4 py-2 bg-primary text-white text-sm font-medium rounded-r hover:bg-primary-dark transition-colors"
                >
                  Enviar
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Payment methods */}
      <div className="border-t border-white/10">
        <div className="container py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-white/70">
              Metodos de pago seguros:
            </p>
            <div className="flex items-center gap-3">
              <PaymentBadge name="VISA" />
              <PaymentBadge name="Mastercard" />
              <PaymentBadge name="Yape" highlight />
              <PaymentBadge name="Plin" highlight />
              <PaymentBadge name="BCP" />
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/10">
        <div className="container py-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-2 text-sm text-white/60">
            <p>
              Pet Mas © {new Date().getFullYear()} Creado por Basla
            </p>
            <p>
              Todos los derechos reservados
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterLink({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <Link
      to={to}
      className="text-white/70 hover:text-primary-light transition-colors"
    >
      {children}
    </Link>
  );
}

function SocialLink({
  href,
  label,
  children,
}: {
  href: string;
  label: string;
  children: React.ReactNode;
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className="p-2.5 rounded-full bg-white/10 text-white/70 hover:bg-primary hover:text-white transition-all duration-300"
    >
      {children}
    </a>
  );
}

function PaymentBadge({ name, highlight }: { name: string; highlight?: boolean }) {
  return (
    <div
      className={`rounded-lg px-3 py-1.5 text-xs font-semibold uppercase tracking-wide ${
        highlight
          ? 'bg-primary text-white'
          : 'bg-white/90 text-secondary'
      }`}
    >
      {name}
    </div>
  );
}

function FacebookIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
    </svg>
  );
}

function InstagramIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
    </svg>
  );
}

function TikTokIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
    </svg>
  );
}

function WhatsAppIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

function LocationIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  );
}

function PhoneIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
      />
    </svg>
  );
}

function EmailIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
      />
    </svg>
  );
}
